<template>
  <ElDialog
    class="modal"
    :visible.sync="showModal"
    :width="modalWidth">
    <h2 class="modal__title">
      Спасибо!
    </h2>
    <div class="modal__body">
      <p class="modal__text">
        Ваша заявка отправлена
      </p>
    </div>
    <div class="modal__submit-buttons">
      <BaseButton text="Закрыть окно"
                  size="large"
                  @click.native="closeModal" />
    </div>
  </ElDialog>
</template>

<script>
import modal from "@/mixins/modal";
import BaseButton from '@/components/ui/BaseButton';

export default {
  name: 'ModalRequestCallSuccess',
  components: {
    BaseButton
  },
  props: {
    variant: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      tariffName: '',
    }
  },
  mixins: [modal],
}
</script>